import script from "./ShortcutsHelp.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShortcutsHelp.vue?vue&type=script&setup=true&lang=ts"

import "./ShortcutsHelp.vue?vue&type=style&index=0&id=7546234f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7546234f"]])

export default __exports__